/** Why a document is forwarded to a staff contact instead of filed to a patient chart. */
export enum DocumentForwardingReason {
  NO_PATIENT_INFORMATION = "No patient information",
  GENERAL_DOCUMENT_TO_CLINIC = "General document to the clinic",
}
